import { render, staticRenderFns } from "./UserAttributeFilters.vue?vue&type=template&id=65d87ada&"
import script from "./UserAttributeFilters.vue?vue&type=script&lang=js&"
export * from "./UserAttributeFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d87ada')) {
      api.createRecord('65d87ada', component.options)
    } else {
      api.reload('65d87ada', component.options)
    }
    module.hot.accept("./UserAttributeFilters.vue?vue&type=template&id=65d87ada&", function () {
      api.rerender('65d87ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserAttributeFilters.vue"
export default component.exports